// BreadCrumb.js
import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Typography, Breadcrumbs, Box, Link } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home"; // Import HomeIcon
import Axios from "axios";

const BreadCrumb = () => {
  const location = useLocation();
  const [featureLabels, setFeatureLabels] = useState([]);

  useEffect(() => {
    async function getFeatureLabel() {
      try {
        const url = `${process.env.REACT_APP_NODE_URL}/api/get-feature-lable`;
        const config = { headers: { token: localStorage.getItem("isToken") } };
        const response = await Axios.get(url, config);
        if (response.data?.isSuccess && response.data.result.length > 0) {
          setFeatureLabels(response.data.result);
        }
      } catch (error) {
        console.error("Error fetching feature labels:", error);
      }
    }
    getFeatureLabel();
  }, []);

  const pathnames = location.pathname.split("/").filter((x) => x);

  // If on home, don't show any breadcrumb or just "Home"
  if (
    pathnames.length === 0 ||
    (pathnames.length === 1 && pathnames[0] === "home")
  ) {
    return null; // Or return a simple "Home" title if you prefer
  }

  return (
    <Box sx={{ mb: 1 }}>
      {" "}
      {/* Added some margin-bottom for spacing */}
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {/* UPDATED: Home link with an icon */}
        <Link
          component={RouterLink}
          to="/home"
          sx={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "text.secondary",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          <HomeIcon sx={{ mr: 0.5, fontSize: "inherit" }} />
          Home
        </Link>
        {pathnames.map((value, index) => {
          // Skip 'home' if it's part of the path, as it's already rendered
          if (value.toLowerCase() === "home") return null;

          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;

          // Use your existing logic to find the label
          const displayValue =
            featureLabels.find((item) => item.feature === value)?.lable ||
            value.charAt(0).toUpperCase() + value.slice(1).replace(/-/g, " ");

          return last ? (
            // UPDATED: Styling for the current page
            <Typography
              key={to}
              sx={{
                display: "flex",
                alignItems: "center",
                fontWeight: "600", // Made it a bit bolder
                color: "#3f51b5", // Using a primary blue to match titles
              }}
            >
              {displayValue}
            </Typography>
          ) : (
            // Styling for intermediate links
            <Link
              component={RouterLink}
              to={to}
              key={to}
              sx={{
                textDecoration: "none",
                color: "text.secondary",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {displayValue}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadCrumb;
